import React from 'react';
import { Button, Tooltip } from '@mui/material';

const SaveButton = ({
  onSave,
  disabled = false,
  label = 'Save draft',
  tooltipTitle,
}) => {
  const handleSaveClick = () => {
    if (onSave) {
      onSave();
    }
  };

  return (
    <Tooltip title={tooltipTitle || ''} disableHoverListener={!tooltipTitle}>
      <span>
        <Button
          variant="outlined"
          onClick={handleSaveClick}
          disabled={disabled}
          sx={{
            minHeight: 40,
            px: 2,
            color: 'text.secondary',
            borderColor: 'divider',
            '&:hover': {
              color: 'primary.main',
              borderColor: 'primary.main',
              bgcolor: 'action.hover',
            },
          }}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
};

export default SaveButton;
